import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';
import {List} from 'immutable';
import User, {UserId} from 'records/User';
import {isList} from './immutableUtils';
import {nil} from '@store/@types/util';

/**
 * Fetch users not already in the store by id.
 *
 * @param userIds ids of users to fetch.
 * @param defer boolean
 * @return promise resolving to a list of fetched users.
 */
export default function fetchMissingUsers(
  userIds: List<UserId | nil> | Array<UserId | nil>,
  defer?: false
): Promise<List<User>>;
export default function fetchMissingUsers(
  userIds: List<UserId | nil> | Array<UserId | nil>,
  defer: true
): Promise<void>;
export default function fetchMissingUsers(
  userIds: List<UserId | nil> | Array<UserId | nil>,
  defer = true
) {
  const {users} = UserStore.getState();
  const asList = isList(userIds) ? userIds : List(userIds);
  const missingUserIds = asList.filter(id => !users.has(id!));
  return missingUserIds.size > 0
    ? defer
      ? Promise.resolve(UserActions.fetchAll.defer({ids: missingUserIds}))
      : UserActions.fetchAll({ids: missingUserIds})
    : Promise.resolve(List<User>());
}
